import { accordion } from "@/modules/accordion";

export const initFaqSection = () => {
  accordion();
};
